import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../../../hooks/useLoader";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  FormOperacionControlOperativo,
  FormOperacionControlOperativoDetalle,
  schemaFormOperacionControlOperativo,
  schemaFormOperacionControlOperativoDetalle
} from "./types/types";
import { OperacionControlOperativoFields } from "./types/fields";
import SeccionControlOperativoDatosOperacion from "./components/SeccionControlOperativoDatosOperacion";
import { Box, Stack, Typography } from "@mui/material";
import toast from "react-hot-toast";
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema";
import SeccionControlOperativoDetalleNuevo from "./components/SeccionControlOperativoDetalleNuevo";
import { HttpControlOperativo } from "./api/httpControlOperativo";
import CardActions from "../../components/CardActions";
import { FilePutFields } from "../../api/file-fields";
import { SistemaTipo } from "../../../../types/enum/enum";
import { HttpSistema } from "../../api/httpSistema";
import { ArchivoFormData, SchemaNuevoArchivo } from "../../components/DialogNuevoArchivo";
import { DropzoneField } from "../../../../components/forms/DropzoneField";
import { undefined } from "zod";
import { useSubmitOperacion } from '../../hooks/useSubmitOperacion';

type NuevoSistemaControlOperativoProps = {
  codSistemaPrincipal: number
}

function NuevoSistemaControlOperativo(props: NuevoSistemaControlOperativoProps) {
  const { setSendPromise } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo);

  const { submitOperacion } = useSubmitOperacion();
  const { showLoader, hideLoader } = useLoader();

  const [detalleProvisional, setDetalleProvisional] = useState<FormOperacionControlOperativoDetalle>();

  const formMethods = useForm<FormOperacionControlOperativo>({
    resolver: zodResolver(schemaFormOperacionControlOperativo),
    defaultValues: {
      [OperacionControlOperativoFields.CodPais]: props.codSistemaPrincipal,
      [OperacionControlOperativoFields.FechaCarga]: new Date(),
      [FilePutFields.File]: [],
    }
  });

  const { control, setValue } = formMethods;
  const { fields, append, remove } = useFieldArray({
    control,

    //@ts-ignore esto tira un error de ts porque a react-hook-form no le gusta usar useFieldArray con tipos nativos como File
    name: FilePutFields.File,
  });

  const handleRemoveFile = (index: number) => {
    remove(index);
  };

  const watchDocumentacion = useWatch({ control: formMethods.control, name: FilePutFields.File });

  const detalleFormMethods = useForm<FormOperacionControlOperativoDetalle>({
    resolver: zodResolver(schemaFormOperacionControlOperativoDetalle),
    defaultValues: {
      id: -1,
    }
  });

  const alCrearOperacionControlOperativo = useCallback((data: FormOperacionControlOperativo, selected: number) => {
    detalleFormMethods.handleSubmit((detalleData) => {
      setDetalleProvisional(detalleData);
      const files = data[FilePutFields.File] || [];

      const submitYSubirArchivo = async (payload: any) => {
        const response = await HttpControlOperativo.post(payload);

        if (response.tieneError) return response;

        if (files.length > 0) {
          const uploadPromises = files.map(file => HttpSistema.postArchivo(
            response.data,
            SistemaTipo.ControlOperativo,
            {
              [FilePutFields.CodArchivoTipo]: 11,
              [FilePutFields.CodPais]: props.codSistemaPrincipal,
              [FilePutFields.TieneArchivoFisico]: false,
              [FilePutFields.File]: file,
            }
          ));
          await Promise.all(uploadPromises);
        }

        return response;
      };

      const payload = {
        ...data,
        [FilePutFields.File]: [],
        [OperacionControlOperativoFields.Detalle]: detalleData,
        [OperacionControlOperativoFields.Envio]: selected !== 1,
      };

      submitOperacion(payload, {
        apiCall: submitYSubirArchivo,
        codSistemaPrincipal: props.codSistemaPrincipal,
        successMessage: 'Guardado correctamente.',
      });
    })();
  }, [detalleFormMethods, submitOperacion, props.codSistemaPrincipal, setDetalleProvisional]);

  useEffect(() => {
    let onSend = () => console.log('on send test');

    onSend = () => formMethods.handleSubmit(data => alCrearOperacionControlOperativo(data, 2));

    setSendPromise(onSend);
  }, [formMethods, alCrearOperacionControlOperativo]);



  return (
    <Box>
      <CardActions title='Datos Operación' colapsable>
        <SeccionControlOperativoDatosOperacion
          formMethods={formMethods}
          codSistemaPrincipal={props.codSistemaPrincipal}
          nuevo
        />
        <SeccionControlOperativoDetalleNuevo
          codPais={props.codSistemaPrincipal}
          detalleProvisional={detalleProvisional}
          setDetalleProvisional={setDetalleProvisional}
          formMethods={detalleFormMethods}
        />
        <Stack mt={2} spacing={2}>


          <Typography>
            Documentación respaldatoria
          </Typography>
          <DropzoneField
            name={FilePutFields.File}
            control={formMethods.control}
            setValue={formMethods.setValue}
            multiple
          />

          {
            (watchDocumentacion && watchDocumentacion.length > 0) &&
            watchDocumentacion.map((f: File, index: number) => (
              <ArchivoFormData
                key={index}
                archivo={f}
                onRemove={() => handleRemoveFile(index)}
              />
            ))
          }



        </Stack>
      </CardActions>
    </Box>
  );
}

export default NuevoSistemaControlOperativo;